export default function(ngModule) {
    ngModule.factory('User', function(BaseClass, $q, $http, $rootScope, Role, $log, $state) {

        const urlPrefix = AUTH_API_ROOT;

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function User(attributes) {
            _.assign(this, attributes);
        }

        User.modelName = 'User';


        BaseClass.apply(User);

        User.validates({
            name: {
                required: true
            },
            email: {
                format: {email: true},
                required: true
            },
            password: {
                requiredIf: {
                    requiredIf: function(val, instance, field) {
                        return instance.guid === undefined;
                    }
                },
                length: {
                    min: 4
                }
            }
        });

        User.configureApi(urlPrefix + '/user/:guid', {queryAdmin: urlPrefix + '/user/:status/:company'});
        Object.defineProperties(User.prototype, {
            toString: {
                value: function() {
                    return `${this.name} (${this.email})`;
                },
                enumerable: false,
                configurable: false
            }
        });
        User.configureAPIMessages({
            'DELETE /roles/:user_id/:role_id': {
                400: 'models.role.notice.roleLoss'
            }
        });

        User.getMe = function() {
            let userPromise = $q.reject();

            if (User.cached.me)
                userPromise = $q.resolve(User.cached.me);
            else
                userPromise = $http.get(urlPrefix + '/user/me').then(response => User.new(response.data));

            return userPromise.then(user => {
                User.cached.me = user;
                return $q.resolve(User.cached.me);
            });
        };

        User.belongsToMany('Role', 'roles', urlPrefix + '/roles/:guid/^id', [
            {
                type: 'attach',
                fn: (modelName, url, user, role, pivot) => {

                    return $http.put(url, pivot).then(response => {
                        user.broadcastAPIMessage(response);

                        user.belongsToMany.cache(modelName, role, pivot);

                        return $q.resolve(user);
                    }, error => {
                        user.broadcastAPIMessage(error);

                        return $q.reject(error);
                    });

                }
            },
            {
                type: 'detach',
                fn: (modelName, url, user, role) => {

                    return $http.delete(url).then(response => {

                        user.broadcastAPIMessage(response);

                        user.belongsToMany.remove(modelName, role);

                        role.belongsToMany.remove(user.constructor.modelName, user);

                        return $q.resolve(user);

                    }, error => {

                        user.broadcastAPIMessage(error);

                        return $q.reject(error);

                    });

                }
            },
            {
                type: 'query',
                fn: (modelName, url, user, cacheOnly = false) => {

                    // CacheOnly false, because managing users with admin alias will use the cached roles otherwise.
                    // Roles are hardly ever used, so retrieving them here is a small price to pay.

                    if (cacheOnly !== false && (user.belongsToMany[modelName] || cacheOnly)) {
                        return $q.resolve(user.belongsToMany.restore(modelName));
                    }

                    return $http.get(url).then(response => {

                        user.broadcastAPIMessage(response);

                        let models = _.map(response.data, role => {
                            role = Role.new(role);

                            user.belongsToMany.cache(modelName, role);

                            return role;
                        });

                        return $q.resolve(models);

                    }, (error) => {

                        user.broadcastAPIMessage(error);

                        return $q.reject(error);

                    });

                }
            }
        ]);

        User.belongsToMany('Role', 'roles', urlPrefix + '/roles/:guid', [
            {
                type: 'query',
                fn: (modelName, url, user, cacheOnly = false) => {

                    // CacheOnly false, because managing users with admin alias will use the cached roles otherwise.
                    // Roles are hardly ever used, so retrieving them here is a small price to pay.

                    if (cacheOnly !== false && (user.belongsToMany[modelName] || cacheOnly)) {
                        return $q.resolve(user.belongsToMany.restore(modelName));
                    }

                    return $http.get(url + "/fromtoken").then(response => {

                        user.broadcastAPIMessage(response);

                        let models = _.map(response.data, role => {
                            role = Role.new(role);

                            user.belongsToMany.cache(modelName, role);

                            return role;
                        });

                        return $q.resolve(models);

                    }, (error) => {

                        user.broadcastAPIMessage(error);

                        return $q.reject(error);

                    });

                }
            }
        ], "TokenRoles");

        User.belongsTo('Company', 'company_id', 'guid', urlPrefix + '/company/^guid');

        User.prototype.isAdmin = function() {
            $log.error('Dont rely on this auth check!!');
            return Role.isAdmin;
        };

        return User;
    });
}
